'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import UIModal from 'UIComponents/dialog/UIModal';
export var StyledModal = styled(function (props) {
  var __ = props.hideBackground,
      ModalComponent = props.ModalComponent,
      rest = _objectWithoutProperties(props, ["hideBackground", "ModalComponent"]);

  return React.createElement(ModalComponent, rest);
}).withConfig({
  displayName: "StyledModal",
  componentId: "sc-68kg5v-0"
})(["&&&{background-color:", ";}"], function (props) {
  return props.hideBackground ? 'transparent' : undefined;
});
StyledModal.defaultProps = {
  ModalComponent: UIModal
};